'use strict'

import angular from 'angular'

import buySheetTableComplexFieldsListComponentHtmlUrl from './buySheetTableComplexFieldsList.component.html'

angular.module('buySheet.components').component('buySheetTableComplexFieldsList', {
    templateUrl: buySheetTableComplexFieldsListComponentHtmlUrl,
    bindings: {
        idColumnName: '<',
        headers: '<',
        headersKey: '<',
        fields: '<'
    },
    controllerAs: 'vm'
})